import { createSelector } from 'reselect';

import type { State } from '../store';
import type { CommentThreadNode } from './utils';
import { parseComments } from './utils';

// Comments
const selectComments = (state: State) => state.comments;

export const selectSortedComments = createSelector([selectComments], commentsMap => {
  return Object.values(commentsMap).sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
});

export const selectComment = createSelector(
  [selectComments, (_, commentId: string) => commentId],
  (commentsMap, commentId) => commentsMap[commentId]
);

export const selectCommentReplies = createSelector(
  [selectSortedComments, (_, commentId: string) => commentId],
  (comments, commentId) => {
    return comments.filter(comment => comment.parent_id === commentId);
  }
);

// CommentThreads (tree-like)
const selectCommentThreads = createSelector([selectSortedComments], comments => {
  return parseComments(comments).nodesMap;
});

export const selectSortedCommentThreads = createSelector([selectCommentThreads], commentThreadsMap => {
  return Object.values(commentThreadsMap).sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
});

export const selectCommentThread = createSelector(
  [selectCommentThreads, (_, threadId: string) => threadId],
  (threadsMap, threadId) => {
    return threadsMap[threadId] as CommentThreadNode | undefined;
  }
);
